export const TESTIMONIAL_POSTER = "/public/plan-ahead-testimonial-poster.webp";
export const TESTIMONIAL_THUMBNAIL =
  "/public/plan-ahead-testimonial-thumb.webp";

const SLOW_CONNECTION_TYPES = new Set(["slow-2g", "2g", "3g"]);

interface ConnectionHints {
  saveData?: boolean;
  effectiveType?: string;
}

export interface VideoSource {
  src: string;
  type: string;
}

const AUDIO_CODEC = "mp4a.40.2";

// Each file name ends in the first 8 hex characters of the file's SHA-256.
// CDN objects are cached as immutable, so a re-encode ships under its new
// hash rather than overwriting the old object.
const STANDARD_SOURCES = [
  { file: "540x960-av1-0ea4815a", codec: "av01.0.05M.08" },
  { file: "540x960-hevc-5f2722c5", codec: "hvc1.1.6.L93.B0" },
  { file: "540x960-h264-4298ea36", codec: "avc1.64001F" },
];

const LITE_SOURCES = [
  { file: "360x640-lite-av1-4fb3d027", codec: "av01.0.05M.08" },
  { file: "360x640-lite-hevc-474fd0b8", codec: "hvc1.1.6.L93.B0" },
  { file: "360x640-lite-h264-c6dc445e", codec: "avc1.4D401E" },
];

/** The testimonial's sources in preference order — AV1, then HEVC, then
 * H.264 — so the browser plays the first it supports. A data-saver or slow
 * connection gets the lite tier, everyone else the standard one. */
export function testimonialVideoSources(
  cdnHost: string,
  connection: ConnectionHints | null | undefined,
): VideoSource[] {
  const slow =
    connection?.saveData === true ||
    SLOW_CONNECTION_TYPES.has(connection?.effectiveType ?? "");
  return (slow ? LITE_SOURCES : STANDARD_SOURCES).map(({ file, codec }) => ({
    src: `${cdnHost}/videos/plan-ahead-testimonial-${file}.mp4`,
    type: `video/mp4; codecs="${codec}, ${AUDIO_CODEC}"`,
  }));
}
